import Registrations from "./Registrations";

export default Registrations;



// WEBPACK FOOTER //
// ./src/components/Registrations/index.js